import React, { useEffect, useState, useMemo, useRef } from 'react';
import classNames from 'classnames';
import PageTitle from '../../atoms/PageTitle';
import { BookingProducts, ContractPeriodOptions, PurposeOfContractOptions, UsageTimeOptionsAnnual, UsageTimeOptionsMonthly, UserTypeOptions } from '../../../utils/EstimateFormData';
import RadioGroup from '../../atoms/Radio/RadioGroup';
import Radio from '../../atoms/Radio';
import BookingItem from '../../molecules/BookingItem';
import Input from '../../atoms/Input';
import BookingFormSummary from '../../atoms/BookingFormSummary';
import Button from '../../atoms/Button';
import { URLS } from '../../../utils/urls';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useBookingOptionContext } from '../../organisms/BookingOptionContext';
import { getValueByTarget } from '../../../utils/parse';
import { useForm } from 'react-hook-form';
import { updateBusinessLicenseImage, updateUserInformation } from '../../../reducers/bookingEstimation';
import AddressInput2 from '../../molecules/AddressInput2';
import Icon from '../../atoms/Icon';
import { formErrorMessage } from '../../../utils/alertMessage';
import { SetMmEstimateHistory, getEstimateHistoryInfo, setSheetContractResponse } from '../../../lib/EstimateApi';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { base64EncodeUnicode, getBusinessCodeFormat, getEnglishDayToKorean, getEstimateCookieData, getEstimateCookieDataAndDecrypt, sleep } from '../../../lib/Util';
import { uploadFile } from '../../../lib/MsAzureApi';
import { openLoading, closeLoading } from '../.././../reducers/loadingRedux'
import { ESTIMATE_TYPE_MONTHLY_MOSILER, PAGE } from '../../../utils/constant';
import { SendSlackContracting } from '../../../lib/SlackApi';
import { SendEztoc2 } from '../../../lib/EztocApi';
import Select from '../../atoms/Select';
import SelectObj from '../../atoms/SelectObj';
import SubscribeApi from '../../../lib/SubscribeApi';
import InputWithLabel from '../../atoms/InputWithLabel';
import InputWithLabelAndList from '../../atoms/InputWithLabelAndList';
import CheckBox2 from '../../atoms/CheckBox2';
import { isNullOrUndef } from 'chart.js/helpers';
import Modal3 from '../../molecules/Modal3';
import useCheckPC from '../../../hooks/useCheckPC';
import { getModusignContractDraft, getRequestWithTemplate, SetSubscribeContract } from '../../../lib/SignatureApi';
import { transFormWon2 } from '../../../utils/numbers';
import ko from 'date-fns/locale/ko';
import DatePicker from 'react-datepicker';
import DatePickerInput from '../../molecules/DatePickerInput';

/**
 * 계약서 확인 > 고객 정보 페이지
 * name : userInformation
 * */

const UserInformationAdmin = () => {
	const inputRef = useRef(null);
	const customerCheckDebounceRef = useRef(null);
	const { isPC } = useCheckPC();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { selectedOptions, setSelectedOptions } = useBookingOptionContext();
	const [description, setDescription] = useState([]);

	const [file, setFile] = useState(selectedOptions.userInformation.user.businessRegistration ?? null);
	const isExistsImages = useMemo(() => file?.length > 0, [file?.length]);

	const [userType, setUserType] = useState(selectedOptions.userInformation.userType)
	const { BookingOption } = useSelector((state) => state);
	const [fileManage, setFileManage] = useState(null)
	const [productList, setProductList] = useState([])
	const [popupPreviewFlag, setPopupPreviewFlag] = useState(false)
	const [BackEstimateUrl, setBackEstimateUrl] = useState('about:blank')
	const [PreviewUrl, setPreviewUrl] = useState('about:blank')
	const [selectedDate, setSelectedDate] = useState()
	const [PurchaseDate, setPurchaseDate] = useState(moment().add(7, 'days').toDate())





	const [selectedProduct, setSelectedProduct] = useState({
		label: `선택하세요`,
		value: `0`,
		data: {
			"SubsGoodsCd": 0,
			"SubsSType": "",
			"SubsSName": "",
			"SaleStartDt": "",
			"SaleEndDt": "",
			"ApplyStatus": "",
			"SubsGoodsDay": 0,
			"SubsGoodsHour": 0,
			"PerHourAmt": 0,
			"MinApplyHour": 0,
			"NOFF": 0,
			"SubsGoodsAmt": 0,
			"RegId": 0,
			"UpdateId": 0,
			"RegDt": "",
			"UpdateDt": "",
			"OptionList": []

		}
	})

	const [selectedOption, setSelectedOption] = useState({
		option01: '0',
		option02: '0',
		option03: '0',
		option04: '0',
		option05: '0',
		option06: '0',
	})

	const [subscribeData, setSubscribeData] = useState({
		ContractStartDate: '',
		ContractTypeDay: 0,
		ContractTypeHour: 0,
		ContractOneDayAvaliableHour: 0,
		MmHourPrice: 0,
		ContractMonth: 0,
		ContractMonthDiscountPercent: 0,
		SubscriptionType: '',
		SubscriptionFullText: '',
		PromotionDiscountPercent: 0,
		CustomerName: '',
		ContractName: '',
		EmailAddress: '',
		PhoneNumber: '',
		PromotionAnnualMonth: 0,
		PromotionPrePaidTicket: 0,
		PaymentType: '선택하세요.'
		// Option 추가 필요.
	})

	const [customerCheckResult, setCustomerCheckResult] = useState({
		status: 'idle',
		message: '',
		customerNo: null,
	});

	const [selectedTempInfo, setSelectedTempInfo] = useState(null);
	const [showPhoneList, setShowPhoneList] = useState(false);
	const [tempCustomerList, setTempCustomerList] = useState([]);

	const JoinCheckStatusIcon = (status) => {
		if (status === 'idle') {
			return '⏰'
		}
		else if (status === 'loading') {
			return '📃'
		}
		else if (status === 'success') {
			return '🟢'
		}
		else if (status === 'error') {
			return '🟠'
		}
		return '❓'

	}

	// useEffect(() => {
	// 	const hasContactValues = !!(subscribeData?.EmailAddress || subscribeData?.PhoneNumber);

	// 	if (!hasContactValues) {
	// 		setCustomerCheckResult({
	// 			status: 'idle',
	// 			message: '',
	// 			customerNo: null,
	// 		});
	// 		setTempCustomerList([]);
	// 		if (customerCheckDebounceRef.current) {
	// 			clearTimeout(customerCheckDebounceRef.current);
	// 		}
	// 		return;
	// 	}

	// 	if (customerCheckDebounceRef.current) {
	// 		clearTimeout(customerCheckDebounceRef.current);
	// 	}

	// 	customerCheckDebounceRef.current = setTimeout(async () => {
	// 		try {
	// 			setCustomerCheckResult(prev => ({
	// 				...prev,
	// 				status: 'loading',
	// 				message: '고객 정보 확인 중...',
	// 			}));

	// 			const response = await fetch('http://localhost:3000/api/common/temp-customer-check', {
	// 				method: 'POST',
	// 				headers: {
	// 					'Content-Type': 'application/json',
	// 				},
	// 				body: JSON.stringify({
	// 					SearchKeyword: subscribeData?.PhoneNumber || subscribeData?.EmailAddress || ''
	// 				}),
	// 			});

	// 			if (!response.ok) {
	// 				throw new Error('API 호출 실패');
	// 			}

	// 			const result = await response.json();

	// 			if (result?.ResultData && Array.isArray(result.ResultData)) {
	// 				setTempCustomerList(result.ResultData);
	// 				setCustomerCheckResult({
	// 					status: 'success',
	// 					message: result?.ResultMessage ?? '',
	// 					customerNo: null,
	// 				});
	// 			} else {
	// 				setTempCustomerList([]);
	// 				setCustomerCheckResult({
	// 					status: 'success',
	// 					message: '검색 결과가 없습니다.',
	// 					customerNo: null,
	// 				});
	// 			}
	// 		}
	// 		catch (error) {
	// 			setTempCustomerList([]);
	// 			setCustomerCheckResult({
	// 				status: 'error',
	// 				message: '고객 정보 확인 실패',
	// 				customerNo: null,
	// 			});
	// 		}
	// 	}, 1000);

	// 	return () => {
	// 		if (customerCheckDebounceRef.current) {
	// 			clearTimeout(customerCheckDebounceRef.current);
	// 		}
	// 	};
	// }, [subscribeData?.PhoneNumber, subscribeData?.EmailAddress]);

	const [finalCalcData, setFinalCalcData] = useState(0)

	useEffect(() => {
		const { ContractTypeDay, ContractTypeHour, ContractOneDayAvaliableHour, MmHourPrice, ContractMonthDiscountPercent, PromotionDiscountPercent } = subscribeData

		let optAll = 0
		for (let i of Object.keys(selectedOption)) {
			optAll += Number(selectedOption[i])
		}
		let calcResult = (((ContractTypeDay ?? 0) * (ContractTypeHour ?? 0)) * ((MmHourPrice ?? 0) - ((MmHourPrice ?? 0) * ((PromotionDiscountPercent ?? 0) / 100)))) + optAll

		setFinalCalcData(calcResult)
	}, [subscribeData, selectedOption])


	const EstimatePreview = (action = 'preview') => {
		const { ContractStartDate, ContractTypeDay, ContractTypeHour, ContractOneDayAvaliableHour, MmHourPrice, ContractMonth, ContractMonthDiscountPercent, SubscriptionType, SubscriptionFullText, CustomerName, PromotionDiscountPercent, PromotionAnnualMonth, PromotionPrePaidTicket } = subscribeData

		const opt = [
			{ label: 'option01', title: '운행 등록차량 추가', list: [{ title: '없음', price: '0' }, { title: '운행 등록차량 추가', price: '150700' }] },
			{ label: 'option02', title: '특장차량 / 2억원 이상 차량', list: [{ title: '없음', price: '0' }, { title: '특장차량 / 2억원 이상', price: '100100' }] },
			{ label: 'option03', title: '사용자 보험 사용 할인', list: [{ title: '없음', price: '0' }, { title: '고객보험할인', price: '-100100' }] },
			{ label: 'option04', title: '파트너 1인 지명', list: [{ title: '없음', price: '0' }, { title: '파트너 1인 지명', price: '198000' }] },
			{ label: 'option05', title: '언어수당', list: [{ title: '없음', price: '0' }, { title: '언어수당', price: '198000' }] },
			{ label: 'option06', title: '차량포함', list: [{ title: '없음', price: '0' }, { title: '차량포함', price: '605000' }] },
		]

		const OptionInfo = []
		for (let i of Object.keys(selectedOption)) {

			if (selectedOption[i] != '0') {
				const findObj = opt.find((d) => d.label === i)
				if (i === 'option03') {
					OptionInfo.push({ title: findObj?.title, discount: Math.abs(Number(selectedOption[i])) })
				}
				else {
					OptionInfo.push({ title: findObj?.title, price: Number(selectedOption[i]) })
				}
			}
		}
		const PeriodOfContract = [];
		if (ContractMonth >= 1) {
			PeriodOfContract.push({ title: `${ContractMonth}개월`, discount: ContractMonthDiscountPercent })
		}

		const Promotion = []
		if (PromotionDiscountPercent >= 1) {
			const productAmount = ((ContractTypeDay ?? 0) * (ContractTypeHour ?? 0)) * MmHourPrice ?? 0
			const discountAmount = (((ContractTypeDay ?? 0) * (ContractTypeHour ?? 0)) * ((MmHourPrice ?? 0) - ((MmHourPrice ?? 0) * ((PromotionDiscountPercent ?? 0) / 100))))

			Promotion.push({ title: `프로모션 할인(${PromotionDiscountPercent}%)`, discount: productAmount - discountAmount })
		}

		let ProductTitle = (selectedProduct?.data?.SubsSType === 'MONTHLY') ? '월간 모시러' : '연간 모시러'
		let ProductName = []
		let ProductInfo = {}
		if (selectedProduct?.data?.SubsSType === 'MONTHLY') {
			ProductTitle = '월간 모시러'


			ProductInfo = {
				Title: '월간 모시러<br>서비스 기본 이용료',
				FileName: `월간모시러 ${ContractTypeDay}일(${(ContractTypeDay * ContractTypeHour)}시간) 상품 견적서_${CustomerName} 고객님`,
				UsageUnit: ContractMonth,
				UsageUnitStr: '개월',
				ContractTypeDay,
				ContractTypeHour,
				ContractOneDayAvaliableHour,
				BasicHour: (ContractTypeDay * ContractTypeHour),
				MmHourPrice,
				PromotionDiscountPercent,
				ProductAmount: ((ContractTypeDay ?? 0) * (ContractTypeHour ?? 0)) * MmHourPrice ?? 0,
				PromotionDiscountAmount: PromotionDiscountPercent >= 1 ? (((ContractTypeDay ?? 0) * (ContractTypeHour ?? 0)) * ((MmHourPrice ?? 0) - ((MmHourPrice ?? 0) * ((PromotionDiscountPercent ?? 0) / 100)))) : 0,
				PromotionAnnualMonth: 0,
				PromotionPrePaidTicket: 0
			}

		}
		else {
			ProductTitle = '연간 모시러'

			ProductInfo = {
				Title: '연간 모시러 회원권',
				FileName: `연간모시러 ${(ContractTypeDay * ContractTypeHour)}시간 상품 견적서_${CustomerName} 고객님`,
				UsageUnit: ContractMonth,
				UsageUnitStr: '년',
				ContractTypeDay,
				ContractTypeHour,
				ContractOneDayAvaliableHour,
				BasicHour: (ContractTypeDay * ContractTypeHour),
				MmHourPrice,
				PromotionDiscountPercent,
				ProductAmount: ((ContractTypeDay ?? 0) * (ContractTypeHour ?? 0)) * MmHourPrice ?? 0,
				PromotionDiscountAmount: PromotionDiscountPercent >= 1 ? (((ContractTypeDay ?? 0) * (ContractTypeHour ?? 0)) * ((MmHourPrice ?? 0) - ((MmHourPrice ?? 0) * ((PromotionDiscountPercent ?? 0) / 100)))) : 0,
				PromotionAnnualMonth,
				PromotionPrePaidTicket
			}
		}
		const data = {
			UserName: CustomerName,
			ProductTitle,
			ProductName,
			PeriodOfContract,
			OptionInfo,
			Promotion,
			ProductInfo,
			AllFee: finalCalcData
		}

		let qsInfo = btoa(encodeURIComponent(JSON.stringify(data)))

		if (action === 'preview') {
			window.open(`${URLS.BOOKING_ESTIMATION_DOWNLOAD_DATAURL_ADMIN}?qsdata=${qsInfo}`)
		}
		else {
			setBackEstimateUrl(`${URLS.BOOKING_ESTIMATION_DOWNLOAD_DATAURL_ADMIN}?qsdata=${qsInfo}&dataonly=true`)
		}
	}

	const saveOption = (subField, value, target) => {
		setSelectedOption((prevState) => ({
			...prevState,
			[target]: value
		}));
	};

	const saveSubscribeData = (target, value) => {
		setSubscribeData((prevState) => {
			return {
				...prevState,
				[target]: value
			}
		});
	};


	const numberWithCommas = (x) => {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	};

	useEffect(() => {
		async function getData() {
			const result = await SubscribeApi.SubscribeList()
			if (result?.ResultCode == 200) {
				const tmpProductArr = [{
					label: `선택하세요`,
					value: `0`,
					data: {}
				}]
				for (const i of result?.ResultData) {
					if (i?.SubsSType == 'MONTHLY') {
						tmpProductArr.push({
							label: `월간 ${i?.SubsGoodsDay}일 ${i?.SubsGoodsHour}시간 ${numberWithCommas(i?.PerHourAmt)}`,
							value: `${i?.SubsGoodsCd}`,
							data: i
						})
					}
					else {
						tmpProductArr.push({
							label: `연간 ${i?.SubsGoodsDay * i?.SubsGoodsHour}시간 ${numberWithCommas(i?.PerHourAmt)}`,
							value: `${i?.SubsGoodsCd}`,
							data: i
						})
					}
				}
				setProductList(tmpProductArr)
			}
		}
		getData();
	}, [])


	useEffect(() => {
		const updatedDescription = [];
		updatedDescription.push(
			`<i class='blue'>
      ${getValueByTarget(
				UserTypeOptions,
				selectedOptions.userInformation.userType,
				'title'
			)}</i> 계약의 형태로 진행됩니다.`
		);
		if (userType !== 'personal') {
			updatedDescription.push(
				`계약 고객님의 성함은 <i class='blue'>${selectedOptions?.userInformation?.user?.name ?? '미입력'}</i> 입니다.`,
				`계약 고객님의 회사명은 <i class='blue'>${selectedOptions?.userInformation?.user?.companyName ?? '미입력'}</i> 입니다.`,
				`사업장의 주소는 <i class='blue'>${selectedOptions?.userInformation?.user?.businessAddress?.address1 ?? '미입력'} ${selectedOptions?.userInformation?.user?.businessAddress?.address2 ?? '미입력'} </i> 입니다.`,
				`사업자 등록번호는 <i class='blue'>${selectedOptions?.userInformation?.user?.businessRegistrationId ?? '미입력'}</i> 입니다.`,
				`사업자 등록증이 ${file ? '첨부 되었습니다.' : '첨부되지 않았습니다.'}`
			);
		}
		else {
			updatedDescription.push(
				`계약 고객님의 성함은 <i class='blue'>${selectedOptions?.userInformation?.user?.name ?? '미입력'}</i> 입니다.`,
				`고객님의 주소는 <i class='blue'>${selectedOptions?.userInformation?.user?.personalAddress ?? '미입력'} ${selectedOptions?.userInformation?.user?.personalAddressDetail ?? '미입력'} </i> 입니다.`,
			)
		}
		setDescription(updatedDescription)
	}, [
		selectedOptions.userInformation.userType,
		selectedOptions.userInformation.user.name,
		selectedOptions.userInformation.user.businessAddress.address1,
		selectedOptions.userInformation.user.businessAddress.address2,
		selectedOptions.userInformation.user.businessRegistrationId,
		selectedOptions.userInformation.user.personalAddress,
		selectedOptions?.userInformation?.user?.personalAddressDetail,
		selectedOptions?.userInformation?.user?.companyName,
		file
	])

	const {
		handleSubmit, setValue, register, setError, clearErrors, reset, formState: { errors } } = useForm({
			defaultValues: {
				userType: selectedOptions?.userInformation?.userType,
				name: selectedOptions?.userInformation?.user?.name,
				zip: selectedOptions?.userInformation?.user?.businessAddress?.zip,
				address1: selectedOptions?.userInformation?.user?.businessAddress?.address1,
				address2: selectedOptions?.userInformation?.user?.businessAddress?.address2,
				businessRegistrationId: selectedOptions?.userInformation?.user?.businessRegistrationId,
				businessRegistration: selectedOptions?.userInformation?.user?.businessRegistration,
				companyName: selectedOptions?.userInformation?.user?.companyName,
				personalAddress: selectedOptions?.userInformation?.user?.personalAddress,
				personalAddressDetail: selectedOptions?.userInformation?.user?.personalAddressDetail,
			}
		});

	const onFileUpload = async () => {
		// *** UPLOAD TO AZURE STORAGE ***
		const blobsInContainer = await uploadFile(fileManage);

		// reset state/form
		setFileManage(null);

		return blobsInContainer
	};



	const onSubmit = handleSubmit(async data => {
		let validCheck = true;
		// 모든 에러를 명시적으로 지워서 새로운 검증 시작
		//clearErrors();

		// console.log(isExistsImages, (file?.images?.length))

		// 상품 상세 정보 유효성 검사
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


		// 개인, 법인/개인 사업자 공통

		// 1. 계약서 받을 이메일주소
		if (!data?.EmailAddress) {
			validCheck = false;
			setError('EmailAddress', {
				type: 'focus',
				name: 'EmailAddress',
				message: '계약서 받을 이메일을 입력해주세요.'
			}, { shouldFocus: true });
		}
		else if (!emailRegex.test(data.EmailAddress)) {
			validCheck = false;
			setError('EmailAddress', {
				name: 'EmailAddress',
				message: '올바른 이메일 주소를 입력해주세요.'
			}, { shouldFocus: true });
		}

		// 2. 전화번호
		if (!data?.PhoneNumber) {
			validCheck = false;
			setError('PhoneNumber', {
				name: 'PhoneNumber',
				message: '청구자 전화번호를 입력해주세요.'
			}, { shouldFocus: true });
		}
		else {
			const digits = String(data.PhoneNumber).replace(/[^0-9]/g, '');
			if (digits.length < 8) {
				validCheck = false;
				setError('PhoneNumber', {
					name: 'PhoneNumber',
					message: '유효한 전화번호를 입력해주세요.'
				}, { shouldFocus: true });
			}
		}

		// 3. 이름
		if (data?.name?.length <= 1) {
			validCheck = false;
			setError('name', {
				type: 'focus',
				name: 'name',
				message: '이름은 2자 이상 입니다.'
			}, { shouldFocus: true });
		}


		// 개인일 경우
		if (userType === 'personal') {
			//개인 - 계약자 주소 (기본주소)
			if (!data?.personalAddress) {
				validCheck = false;
				setError('personalAddress', {
					type: 'focus',
					name: 'personalAddress',
					message: formErrorMessage.addressBasicError
				}, { shouldFocus: true });
			}

			//개인 - 계약자 주소 (상세주소)
			if (!data?.personalAddressDetail) {
				validCheck = false;
				setError('personalAddressDetail', {
					type: 'focus',
					name: 'personalAddressDetail',
					message: formErrorMessage.address2Error
				}, { shouldFocus: true });
			}
		}
		else {
			if (!data?.companyName) {
				validCheck = false;
				setError('companyName', {
					type: 'focus',
					name: 'companyName',
					message: formErrorMessage.companyNameError
				}, { shouldFocus: true });
			}


			if (!data?.address1) {
				validCheck = false;
				setError('address1', {
					type: 'focus',
					name: 'address1',
					message: formErrorMessage.address1Error
				}, { shouldFocus: true });
			}

			if (!data?.address2) {
				validCheck = false;
				setError('address2', {
					type: 'focus',
					name: 'address2',
					message: formErrorMessage.address2Error
				}, { shouldFocus: true });
			}

			if (!data?.businessRegistrationId) {
				validCheck = false;
				setError('businessRegistrationId', {
					type: 'focus',
					name: 'businessRegistrationId',
					message: formErrorMessage.businessRegistrationIdError
				}, { shouldFocus: true });
			}

			if (!isExistsImages) {
				validCheck = false;
				setError('businessRegistration', {
					name: 'businessRegistration',
					message: formErrorMessage.businessRegistrationError
				});
			}

			if (data?.PaymentType === '세금계산서') {
				if (!data?.taxInvoiceEmail) {
					validCheck = false;
					setError('taxInvoiceEmail', {
						type: 'focus',
						name: 'taxInvoiceEmail',
						message: '계산서 받을 이메일을 입력해주세요.'
					}, { shouldFocus: true });
				}
				else if (!emailRegex.test(data.taxInvoiceEmail)) {
					validCheck = false;
					setError('taxInvoiceEmail', {
						name: 'taxInvoiceEmail',
						message: '올바른 이메일 주소를 입력해주세요.'
					}, { shouldFocus: true });
				}
			}
			else {
				clearErrors('taxInvoiceEmail')
			}

		}

		//공통 - 계약일 또는 이용시작일
		if (!data?.selectedDate) {
			validCheck = false;
			setError('selectedDate', {
				type: 'focus',
				name: 'selectedDate',
				message: '날짜를 선택해주세요'
			}, { shouldFocus: true });
		}

		//개인 - 결제수단
		if (!data?.PaymentType || data?.PaymentType === '선택하세요.') {
			console.log('paymenttype', data?.PaymentType)
			validCheck = false;
			setError('PaymentType', {
				type: 'focus',
				name: 'PaymentType',
				message: '결제수단을 선택해주세요'
			}, { shouldFocus: true });

		}

		// 상품선택 미선택시의 에러처리
		if (subscribeData.SubscriptionType === '') {
			validCheck = false;
			setError('selectedProduct', {
				type: 'focus',
				name: 'selectedProduct',
				message: '상품을 선택해주세요'
			}, { shouldFocus: true });
		}

		if (!data?.contractTypeDay || Number(data.contractTypeDay) <= 0) {
			validCheck = false;
			setError('contractTypeDay', {
				type: 'focus',
				name: 'contractTypeDay',
				message: '상품(일)을 입력해주세요.'
			}, { shouldFocus: true });
		}

		if (!data?.contractTypeHour || Number(data.contractTypeHour) <= 0) {
			validCheck = false;
			setError('contractTypeHour', {
				type: 'focus',
				name: 'contractTypeHour',
				message: '상품(시간)을 입력해주세요.'
			}, { shouldFocus: true });
		}

		if (!data?.mmHourPrice || Number(data.mmHourPrice) <= 0) {
			validCheck = false;
			setError('mmHourPrice', {
				type: 'focus',
				name: 'mmHourPrice',
				message: '상품 단가를 입력해주세요.'
			}, { shouldFocus: true });
		}

		if (!data?.ContractOneDayAvaliableHour || Number(data.ContractOneDayAvaliableHour) <= 0) {
			validCheck = false;
			setError('ContractOneDayAvaliableHour', {
				type: 'focus',
				name: 'ContractOneDayAvaliableHour',
				message: '1일 최소 이용시간을 입력해주세요.'
			}, { shouldFocus: true });
		}

		const subsSType = selectedProduct?.data?.SubsSType;
		const contactmonth = subscribeData.ContractMonth;
		if ((subsSType === 'MONTHLY' || subsSType === 'ANNUAL') && (!contactmonth || Number(contactmonth) <= 0)) {
			validCheck = false;
			setError('ContractMonth', {
				type: 'focus',
				name: 'ContractMonth',
				message: '기간(개월/년)을 입력해주세요.'
			}, { shouldFocus: true });
		}

		if (Number(data?.PromotionDiscountPercent || 0) < 0) {
			validCheck = false;
			setError('PromotionDiscountPercent', {
				name: 'PromotionDiscountPercent',
				message: '할인율은 0 이상이어야 합니다.'
			}, { shouldFocus: true });
		}

		if (validCheck) {
			try {
				let resultUploadData = ""
				let uploadComplateFlag = false

				// 이미 사업자 등록증 업로드가 완료되었다면
				if (BookingOption?.userInformation?.user?.businessRegistration?.length >= 1) {
					uploadComplateFlag = true;
				}
				// 존재하지 않는다면?
				else {
					resultUploadData = await onFileUpload()
					setSelectedOptions((prevState) => ({
						...prevState,
						userInformation: {
							...prevState.userInformation,
							user: {
								...prevState.userInformation.user,
								businessRegistration: resultUploadData.url,
							}
						},
					}));
					dispatch(updateBusinessLicenseImage(resultUploadData.url))
				}
				handlePreviewPopup()
			}
			catch (e) {

			}


			// 결제 화면은 Todo
			// navigate(URLS.BOOKING_ESTIMATION_PAYMENT_METHOD)


		}
	});

	const handleAddressChange = (subField, value, target) => {
		setSelectedOptions((prevState) => ({
			...prevState,
			userInformation: {
				...prevState.userInformation,
				user: {
					...prevState.userInformation.user,
					[target]: {
						...prevState.userInformation.user[target],
						[subField]: value,
					},
				},
			},
		}));
	};

	const handleAddressChange2 = (subField, value, target) => {
		setSelectedOptions((prevState) => ({
			...prevState,
			userInformation: {
				...prevState.userInformation,
				user: {
					...prevState.userInformation.user,
					[target]: value
				},
			},
		}));
	};


	const handleAddressChange3 = (subField, value, target) => {
		setSelectedOptions((prevState) => ({
			...prevState,
			userInformation: {
				...prevState.userInformation,
				user: {
					...prevState.userInformation.user,
					businessAddress: {
						...prevState.userInformation.user.businessAddress,
						[target]: value
					}
				},
			},
		}));
	};

	const handleImages = (e) => {
		if (e.target.files.length) {
			setFile(e.target.files[0].name);
			setFileManage(e.target.files[0])
		}
		else {
			setFile('');
			setFileManage(null)
		}
	};

	const GetEstimateInfo = () => {
		/*
userType == personal
고객유형 : selectedOptions.userInformation.userType
계약자 이름 : selectedOptions.userInformation.user.name
계약자 주소
selectedOptions.userInformation.user.personalAddress
selectedOptions.userInformation.user.personalAddressDetail

userType == corporate
계약자 이름 : selectedOptions.userInformation.user.name
회사명: selectedOptions.userInformation.user.companyName
사업자 등록증상 주소
selectedOptions.userInformation.user.address1
selectedOptions.userInformation.user.address2
사업자등록번호
selectedOptions.userInformation.user.businessRegistrationId
*/
		let isMonthly = selectedProduct?.data?.SubsSType === 'MONTHLY'
		const { ContractMonth, PromotionAnnualMonth } = subscribeData
		return {
			CompanyName: (selectedOptions.userInformation.userType === 'personal') ?
				selectedOptions.userInformation.user.name : selectedOptions.userInformation.user.companyName,
			ContractName: selectedOptions.userInformation.user.name,
			EstimateImage: localStorage.getItem('estimate_img'),
			Address: (selectedOptions.userInformation.userType === 'personal') ?
				selectedOptions.userInformation.user.personalAddress + ' ' + selectedOptions.userInformation.user.personalAddressDetail :
				selectedOptions.userInformation.user.businessAddress.address1 + ' ' + selectedOptions.userInformation.user.businessAddress.address2,
			BusinessCode: (selectedOptions.userInformation.userType === 'personal') ?
				'' : getBusinessCodeFormat(selectedOptions.userInformation.user.businessRegistrationId),
			CompanyName2: selectedOptions.userInformation.user.name,
			ProductAllAmount: transFormWon2(finalCalcData),
			// ContractMonth: isMonthly ? `${ContractMonth}개월` : `${Number(ContractMonth) + Number(PromotionAnnualMonth)}개월`,
			ContractMonth: `${Number(ContractMonth) + Number(PromotionAnnualMonth)}개월`,
			ContractStartDate: moment(selectedDate).format('yyyy년 MM월 DD일'),
			ContractEndDate: isMonthly ? moment(selectedDate).add(ContractMonth, 'months').add(-1, 'days').format('yyyy년 MM월 DD일') : moment(selectedDate).add(1, 'years').add(PromotionAnnualMonth, 'months').add(-1, 'days').format('yyyy년 MM월 DD일'),
		}
	}

	const handlePreviewPopup = async () => {
		// 계약서 미리보기를 위한 필요 데이터 세팅
		// 견적서 URL 생성
		// 모두싸인 미리보기 API 호출
		// iframe URL 세팅
		EstimatePreview('createImg')
		dispatch(openLoading())
		let dataurlLoading = null
		while (true) {
			// console.log('while statement')
			await sleep(1000)
			dataurlLoading = localStorage.getItem('estimate_img_processed')
			if (dataurlLoading !== null && dataurlLoading === 'false') {
				localStorage.setItem('estimate_img_processed', true)
				break;
			}
		}

		dataurlLoading = localStorage.getItem('estimate_img_processed')
		console.log(dataurlLoading)
		console.log(selectedOptions.userInformation)

		if (dataurlLoading === 'true') {
			// 모두싸인 데이터 초기화
			let EstimateInfo = GetEstimateInfo()



			let reqData = {
				templateId: "aa8e5680-8845-11ee-87ba-97646ef4c31c",
				document: {
					participantMappings: [
						{
							excluded: false,
							signingMethod: {
								type: "SECURE_LINK",
								value: 'rise@mosiler.com'
							},
							signingDuration: 20160,
							locale: "ko",
							name: EstimateInfo.CompanyName,
							role: "고객"
						}
					],
					requesterInputMappings: [
						{ dataLabel: 'CompanyName', value: EstimateInfo.CompanyName },
						{ dataLabel: 'ProductAllAmount', value: EstimateInfo.ProductAllAmount },
						{ dataLabel: 'ContractStartDate', value: EstimateInfo.ContractStartDate },
						{ dataLabel: 'ContractEndDate', value: EstimateInfo.ContractEndDate },
						{ dataLabel: 'ContractMonth', value: EstimateInfo.ContractMonth },
						{ dataLabel: 'CompanyName2', value: EstimateInfo.CompanyName },
						{ dataLabel: 'BusinessCode', value: EstimateInfo.BusinessCode },
						{ dataLabel: 'Address', value: EstimateInfo.Address },
						{ dataLabel: 'NowDate', value: moment().format('yyyy년 MM월 DD일') },
						{ dataLabel: 'ContractName', value: EstimateInfo.ContractName },
						{ dataLabel: 'EstimateImage', value: { base64: EstimateInfo.EstimateImage } }
					],
					title: "2023 서명테스트"
				},
			}


			let result = await getModusignContractDraft(reqData)

			localStorage.removeItem('estimate_img')
			localStorage.removeItem('estimate_img_processed')
			setBackEstimateUrl('about:blank')

			setPreviewUrl(result.embeddedUrl + '&mode=preview')
			setPopupPreviewFlag(true)

			// localStorage.setItem('estimate_img_processed', 'false')
		}
		dispatch(closeLoading())
	}

	const handleSendContract = async () => {
		const confirmData = window.confirm('고객에게 계약서 발송 하시겠습니까?')
		if (confirmData) {
			const { SubscriptionType, ContractMonth, PromotionAnnualMonth } = subscribeData
			const ismon = SubscriptionType === 'MONTHLY'
			// 옵션 값 세팅
			const opt = [
				{ label: 'option01', title: '운행 등록차량 추가', list: [{ title: '없음', price: '0' }, { title: '운행 등록차량 추가', price: '150700' }] },
				{ label: 'option02', title: '특장차량 / 2억원 이상 차량', list: [{ title: '없음', price: '0' }, { title: '특장차량 / 2억원 이상', price: '100100' }] },
				{ label: 'option03', title: '사용자 보험 사용 할인', list: [{ title: '없음', price: '0' }, { title: '고객보험할인', price: '-100100' }] },
				{ label: 'option04', title: '파트너 1인 지명', list: [{ title: '없음', price: '0' }, { title: '파트너 1인 지명', price: '198000' }] },
				{ label: 'option05', title: '언어수당', list: [{ title: '없음', price: '0' }, { title: '언어수당', price: '198000' }] },
				{ label: 'option06', title: '차량포함', list: [{ title: '없음', price: '0' }, { title: '차량포함', price: '605000' }] },
			]

			const OptionInfo = []
			for (let i of Object.keys(selectedOption)) {
				if (selectedOption[i] != '0') {
					const findObj = opt.find((d) => d.label === i)
					if (i === 'option03') {
						OptionInfo.push({ title: findObj?.title, discount: Math.abs(Number(selectedOption[i])) })
					}
					else {
						OptionInfo.push({ title: findObj?.title, price: Number(selectedOption[i]) })
					}
				}
			}

			// 견적서 세팅.
			EstimatePreview('createImg')
			dispatch(openLoading())
			let dataurlLoading = null
			while (true) {
				// console.log('while statement')
				await sleep(1000)
				dataurlLoading = localStorage.getItem('estimate_img_processed')
				if (dataurlLoading !== null && dataurlLoading === 'false') {
					localStorage.setItem('estimate_img_processed', true)
					break;
				}
			}

			dataurlLoading = localStorage.getItem('estimate_img_processed')
			console.log(dataurlLoading)

			if (dataurlLoading === 'true') {
				// 모두싸인 데이터 초기화
				let EstimateInfo = GetEstimateInfo()
				let reqObj = {
					templateId: "aa8e5680-8845-11ee-87ba-97646ef4c31c",
					document: {
						participantMappings: [
							{
								excluded: false,
								signingMethod: {
									type: "EMAIL",
									value: subscribeData.EmailAddress
								},
								signingDuration: 20160,
								locale: "ko",
								name: EstimateInfo.ContractName,
								role: "고객"
							}
						],

						requesterInputMappings: [
							{ dataLabel: "CompanyName", value: EstimateInfo.CompanyName },
							{ dataLabel: "ProductAllAmount", value: EstimateInfo.ProductAllAmount },
							{ dataLabel: "ContractStartDate", value: EstimateInfo.ContractStartDate },
							{ dataLabel: "ContractEndDate", value: EstimateInfo.ContractEndDate },
							{ dataLabel: "ContractMonth", value: EstimateInfo.ContractMonth },
							{ dataLabel: "CompanyName2", value: EstimateInfo.CompanyName },
							{ dataLabel: "BusinessCode", value: EstimateInfo.BusinessCode },
							{ dataLabel: "Address", value: EstimateInfo.Address },
							{ dataLabel: "NowDate", value: moment().format('yyyy년 MM월 DD일') },
							{ dataLabel: "ContractName", value: EstimateInfo.ContractName },
							{ dataLabel: "EstimateImage", value: { base64: EstimateInfo.EstimateImage } }
						],
						carbonCopies: [{
							contact: subscribeData.EmailAddress
						}],
						title: `${moment().format('yyyyMMDD')}_${EstimateInfo.ContractName}_구독상품_계약`
					},
				}

				// 이부분 동작 잘 되는 거 확인했음.
				let result = await getRequestWithTemplate(reqObj)
				// let result = {}


				// selectedOption={subscribeData.PaymentType}
				// options={['선택하세요.', '카드', '세금계산서', '현금영수증']}

				const paymentTypeMap = {
					'카드': 1,
					'세금계산서': 2,
					'현금영수증': 3,
				};

				const ContractInvoiceBasicInfo = {
					ModusignDocumentId: result?.id ?? '000000-11-22-3344',      // 모두싸인의 DocumentId  
					EmailAddress: subscribeData.EmailAddress,                 // 임시고객의 이메일
					PhoneNumber: subscribeData?.PhoneNumber,                   // 임시고객의 연락처
					CustomerName: subscribeData?.CustomerName,                 // 임시고객의 고객명
					UserInfomation: {
						...selectedOptions.userInformation,
						user: {
							...selectedOptions.userInformation.user,
							taxInvoiceEmail: (subscribeData.PaymentType === '세금계산서') ?
								selectedOptions.userInformation.user.taxInvoiceEmail : ''
						}
					},
					ContractStartDate: moment(selectedDate).format('yyyy-MM-DD'),                     // 이용시작일
					ContractEndDate: ismon ?
						moment(selectedDate).add(ContractMonth, 'months').add(-1, 'days').format('yyyy-MM-DD') :
						moment(selectedDate).add(1, 'years').add(PromotionAnnualMonth, 'months').add(-1, 'days').format('yyyy년 MM월 DD일'),  // 이용종료일
					PaymentType: paymentTypeMap[subscribeData.PaymentType] ?? 0,       // 결제 수단
					PaymentDeadline: moment(PurchaseDate).format('yyyy-MM-DD'),			// 결제 마감일

					SubscriptionType: subscribeData.SubscriptionType,      // 상품 타입 (MONTHLY, ANNUAL)
					ContractTypeDay: subscribeData.ContractTypeDay,     // 상품(일)
					ContractTypeHour: subscribeData.ContractTypeHour,   // 상품(시간)
					MmHourPrice: subscribeData.MmHourPrice,             // 상품 단가
					ContractOneDayAvaliableHour: subscribeData.ContractOneDayAvaliableHour,      // 1일 최소 이용시간
					ContractMonth: subscribeData.ContractMonth,            // 상품 타입이 MONTHLY일때 : 개월, ANNUAL일때 : 개월
					PromotionDiscountPercent: subscribeData.PromotionDiscountPercent,   // 프로모션 할인율 (%)
					PromotionAnnualMonth: ismon ? 0 : subscribeData.PromotionAnnualMonth,             // 프로모션 연장 기간(개월)
					PromotionPrePaidTicket: ismon ? 0 : subscribeData.PromotionPrePaidTicket,         // 프로모션 - 충전(시간)
					
					OptionInfo,    // 옵션
					
					AllFee: finalCalcData,
					
					// TempCustomerNo: selectedTempInfo?.TempCustomerNo,                                       // 임시고객코드
					// CustomerNo: null,    // 고객코드 (있다면 코드번호. 없다면 null)
					// ContractName: selectedTempInfo?.UserName,                 // 임시고객의 고객명
					
				}
				/*
				setSelectedOptions((prevState) => ({
					...prevState,
					userInformation: {
						...prevState.userInformation,
						user: {
							...prevState.userInformation.user,
							taxInvoiceEmail: e.target.value
						},
					},
				}));
				 */

				await SetSubscribeContract(ContractInvoiceBasicInfo)
				console.log(ContractInvoiceBasicInfo)
				// console.log(result)
				alert('고객에게 계약서 발송이 완료 되었습니다.')
			}


			if (isPC) {
				document.getElementById('bookingboxId').style.paddingLeft = 50 + 'px';
				document.getElementById('bookingboxId').style.paddingRight = 50 + 'px';
			}
			else {
				document.getElementById('bookingboxId').style.paddingLeft = 25 + 'px';
				document.getElementById('bookingboxId').style.paddingRight = 25 + 'px';
			}
			setPopupPreviewFlag(false)
			dispatch(closeLoading())
		}
	}

	const handleClosePreviewPopup = async () => {
		if (isPC) {
			document.getElementById('bookingboxId').style.paddingLeft = 50 + 'px';
			document.getElementById('bookingboxId').style.paddingRight = 50 + 'px';
		}
		else {
			document.getElementById('bookingboxId').style.paddingLeft = 25 + 'px';
			document.getElementById('bookingboxId').style.paddingRight = 25 + 'px';
		}
		setPopupPreviewFlag(false)
	}

	const OptionComponent = ({ title, selected, optionList, saveOptionId, discountFlag = false }) => {
		return (<div className={'booking-form-item'}>
			<span className={classNames('title-mid-small')}>{title}</span>
			<RadioGroup
				classes={''}
				legend={'carAmount'}
				selected={selected}
			>
				<ul className={classNames('booking-item-list row')}>
					{optionList.map((item) => (
						<li key={item.title}>
							<Radio
								key={item.title}
								onChange={e => {
									console.log(item.price)
									saveOption(undefined, item.price, saveOptionId)
								}}
							>
								<BookingItem
									selected={selected === item.price}
									subtitle={item?.title}
									price={!discountFlag ? item?.price : undefined}
									discount={discountFlag ? Math.abs(item?.price + '') : undefined}
									priceVisibleFlag={true}
									admin
								/>
							</Radio>
						</li>
					))}
				</ul>
			</RadioGroup>
		</div>)
	}

	const PreviewModal = () => {
		return (
			<Modal3
				title={'계약서 미리보기'}
				style={{}}
			>
				<div className={classNames('main-set')}>
					<iframe id="iframe" src={PreviewUrl} style={{ width: '100%', height: '650px', border: '1px solid #a5a5a5', transform: 'scale(1)' }} />
				</div>
				<div className={classNames('button-set')}>
					<Button 
					type='button'
					onClick={() => {
						handleSendContract()
					}}>
						고객에게 계약서 발송
					</Button>
					<Button
						// styleType={'secondary'}
						onClick={async () => {
							handleClosePreviewPopup()
						}}
					>
						닫기
					</Button>
				</div>
			</Modal3>
		)
	}

	return (
		<>

			<div style={{ position: 'fixed', bottom: 0, left: 0, width: '100%', height: '30px', backgroundColor: '#eee', textAlign: 'center', zIndex: 1000 }}>
				<span style={{ fontSize: '16px', fontWeight: 'bold' }}>{numberWithCommas(finalCalcData + '')}</span>
			</div>
			<div className={classNames('booking-wrap')}>
				<PageTitle title={'관리자 전용'} subtitle={'계약에 필요한 정보를 입력하세요.'} />

				<form className={classNames('booking-form')} onSubmit={onSubmit}>
					<div className={classNames('booking-form-list')}>

						{true && <>
							{!!UserTypeOptions && (
								<div className={'booking-form-item'}>
									<span className={classNames('title-mid')}>고객 유형</span>
									<RadioGroup
										classes={''}
										legend={'purposeOfContract'}
										selected={selectedOptions.userInformation.userType}
									>
										<ul className={classNames('booking-item-list row')}>
											{UserTypeOptions.map((item) => (
												<li key={item.title}>
													<Radio
														key={item.title}
														value={item.value}
														onChange={e => {
															setValue('userType', item.value);
															setUserType(item.value)
															setSelectedOptions((prevState) => ({
																...prevState,
																userInformation: {
																	...prevState.userInformation,
																	userType: item.value,
																},
															}));
															saveSubscribeData('PaymentType', '선택하세요.')
														}}
													>
														<BookingItem
															selected={selectedOptions.userInformation.userType === item.value}
															subtitle={item?.title}
															isAlignCenter={true}
														/>
													</Radio>
												</li>
											))}
										</ul>
									</RadioGroup>
								</div>
							)}

							<div className={'booking-form-item'}>
								<span className={classNames('title-mid')}>계약서 받을 이메일주소</span>
								<InputWithLabel
									label=''
									type={'text'}
									value={subscribeData.EmailAddress}
									required
									{...register('EmailAddress')}
									setValue={setValue}
									error={errors.EmailAddress}
									onChange={e => {
										setValue('EmailAddress', e.target.value)
										saveSubscribeData('EmailAddress', e.target.value)
									}}
									placeholder={'계약서 받을 이메일주소'}
								/>
							</div>

							<div className={'booking-form-item'}>
								<span className={classNames('title-mid')}>전화번호</span>
								<InputWithLabel
									type={'text'}
									required
									{...register('PhoneNumber')}
									setValue={setValue}
									error={errors.PhoneNumber}
									onChange={e => {
										setValue('PhoneNumber', e.target.value)
										saveSubscribeData('PhoneNumber', e.target.value)
									}}
									placeholder={'전화번호'}
								/>
							</div>


							<div className={'booking-form-item'}>
								<span className={classNames('title-mid')}>계약자 이름</span>

								<Input
									type={'text'}
									required
									setValue={setValue}
									error={errors.name}
									{...register('name')}
									onChange={e => {
										setValue('name', e.target.value)
										setSelectedOptions((prevState) => ({
											...prevState,
											userInformation: {
												...prevState.userInformation,
												user: {
													...prevState.userInformation.user,
													name: e.target.value
												},
											},
										}));
										saveSubscribeData('CustomerName', e.target.value)
									}}
									placeholder={'계약자 이름'}

								/>
							</div>

							{userType === 'personal' && (
								<>
									<div className={'booking-form-item'}>
										<span className={classNames('title-mid')}>계약자 주소</span>
										<AddressInput2
											register={register}
											setValue={setValue}
											// zipError={errors.zip}
											address1Error={errors.personalAddress}
											// address2Error={errors.address2}
											// zipRegister={'zip'}
											address1Register={'personalAddress'}
											// address2Register={'address2'}
											setSelectedOptions={setSelectedOptions}
											handleAddressChange={handleAddressChange2}
											target={'personalAddress'}
											placeholder={'주소지를 입력해주세요'}
										/>

										<Input
											type={'text'}
											required
											setValue={setValue}
											error={errors.personalAddressDetail}
											{...register('personalAddressDetail')}
											onChange={e => {
												setValue('personalAddressDetail', e.target.value)
												setSelectedOptions((prevState) => ({
													...prevState,
													userInformation: {
														...prevState.userInformation,
														user: {
															...prevState.userInformation.user,
															personalAddressDetail: e.target.value
														},
													},
												}));
											}}
											placeholder={'상세주소를 입력해주세요'}
										/>
									</div>


									<div className={'booking-form-item'}>
										<span className={classNames('small')}>"계약일" 또는 "이용시작일"</span>
										<DatePickerInput selectedDate={selectedDate} onDateChange={(data) => {
											setSelectedDate(data)
											setPurchaseDate(moment(data).add(7, 'days').toDate())
											setValue('selectedDate', data)
										}} placeholder='--.--.--' />
										{errors.selectedDate?.message && <span className={classNames('error')}>{errors.selectedDate?.message}</span>}
										<input type='hidden' value={selectedDate} {...register('selectedDate')} />
										결제마감일(계약일 D+7) : {moment(PurchaseDate).format('yyyy-MM-DD')} ({getEnglishDayToKorean(moment(PurchaseDate).format('ddd'))})
									</div>


									<div className={'booking-form-item'}>
										<span className={classNames('small')}>결제 수단</span>
										{userType === 'personal' ? (
											<Select
												selectedOption={subscribeData.PaymentType}
												options={['선택하세요.', '카드', '현금영수증']}
												onOptionChange={data => {
													setValue('PaymentType', data)
													saveSubscribeData('PaymentType', data)
												}}
											/>
										) : (
											<Select
												selectedOption={subscribeData.PaymentType}
												options={['선택하세요.', '카드', '세금계산서', '현금영수증']}
												onOptionChange={data => {
													setValue('PaymentType', data)
													saveSubscribeData('PaymentType', data)
												}}
											/>
										)}
										{errors.PaymentType?.message && <span className={classNames('error')}>{errors.PaymentType?.message}</span>}
										<input type='hidden' value={subscribeData.PaymentType} {...register('PaymentType')} />
									</div>

								</>

							)}



							{userType === 'corporate' && (
								<>


									<div className={'booking-form-item'}>
										<span className={classNames('title-mid')}>회사명</span>
										<Input
											type={'text'}
											required
											{...register('companyName')}
											setValue={setValue}
											error={errors.companyName}
											onChange={e => {
												setValue('companyName', e.target.value)
												setSelectedOptions((prevState) => ({
													...prevState,
													userInformation: {
														...prevState.userInformation,
														user: {
															...prevState.userInformation.user,
															companyName: e.target.value
														},
													},
												}));
											}}
											placeholder={'회사명'}

										/>
									</div>
									<div className={'booking-form-item'}>
										<span className={classNames('title-mid')}>주소</span>
										<AddressInput2
											register={register}
											setValue={setValue}
											// zipError={errors.zip}
											address1Error={errors.address1}
											// address2Error={errors.address2}
											// zipRegister={'zip'}
											address1Register={'address1'}
											// address2Register={'address2'}
											setSelectedOptions={setSelectedOptions}
											handleAddressChange={handleAddressChange3}
											target={'address1'}
										/>
										<Input
											type={'text'}
											required
											setValue={setValue}
											error={errors.address2}
											{...register('address2')}
											onChange={e => {
												setValue('address2', e.target.value)
												setSelectedOptions((prevState) => ({
													...prevState,
													userInformation: {
														...prevState.userInformation,
														user: {
															...prevState.userInformation.user,
															businessAddress: {
																...prevState.userInformation.user.businessAddress,
																address2: e.target.value
															}
														},
													},
												}));
											}}
											placeholder={'상세주소를 입력해주세요'}
										/>
									</div>
									<div className={'booking-form-item'}>
										<span className={classNames('title-mid')}>사업자 등록번호</span>
										<Input
											type={'text'}
											required
											setValue={setValue}
											{...register('businessRegistrationId')}
											error={errors.businessRegistrationId}

											onChange={e => {
												setValue('businessRegistrationId', e.target.value)
												setSelectedOptions((prevState) => ({
													...prevState,
													userInformation: {
														...prevState.userInformation,
														user: {
															...prevState.userInformation.user,
															businessRegistrationId: e.target.value
														},
													},
												}));
											}}
											placeholder={'사업자 등록번호'}

										/>
									</div>



									<div className={'booking-form-item'}>
										<span className={classNames('small')}>"계약일" 또는 "이용시작일"</span>
										<DatePickerInput selectedDate={selectedDate} onDateChange={(data) => {
											setSelectedDate(data)
											setPurchaseDate(moment(data).add(7, 'days').toDate())
											setValue('selectedDate', data)
										}} placeholder='--.--.--' />
										{errors.selectedDate?.message && <span className={classNames('error')}>{errors.selectedDate?.message}</span>}
										<input type='hidden' value={selectedDate} {...register('selectedDate')} />
										결제마감일(계약일 D+7) : {moment(PurchaseDate).format('yyyy-MM-DD')} ({getEnglishDayToKorean(moment(PurchaseDate).format('ddd'))})
									</div>


									<div className={'booking-form-item'}>
										<span className={classNames('small')}>결제 수단</span>
										{userType === 'personal' ? (
											<Select
												selectedOption={subscribeData.PaymentType}
												options={['선택하세요.', '카드', '현금영수증']}
												onOptionChange={data => {
													setValue('PaymentType', data)
													saveSubscribeData('PaymentType', data)
												}}
											/>
										) : (
											<Select
												selectedOption={subscribeData.PaymentType}
												options={['선택하세요.', '카드', '세금계산서', '현금영수증']}
												onOptionChange={data => {
													setValue('PaymentType', data)
													saveSubscribeData('PaymentType', data)
												}}
											/>
										)}
										{errors.PaymentType?.message && <span className={classNames('error')}>{errors.PaymentType?.message}</span>}
										<input type='hidden' value={subscribeData.PaymentType} {...register('PaymentType')} />
									</div>

									{subscribeData.PaymentType === '세금계산서' && (
										<div className={'booking-form-item'}>
											<span className={classNames('title-mid')}>세금계산서 받을 이메일주소</span>
											<Input
												type={'text'}
												required
												setValue={setValue}
												{...register('taxInvoiceEmail')}
												error={errors.taxInvoiceEmail}

												onChange={e => {
													setValue('taxInvoiceEmail', e.target.value)
													setSelectedOptions((prevState) => ({
														...prevState,
														userInformation: {
															...prevState.userInformation,
															user: {
																...prevState.userInformation.user,
																taxInvoiceEmail: e.target.value
															},
														},
													}));
												}}
												placeholder={'세금계산서 받을 이메일주소'}

											/>
										</div>

									)}

									<div className={'booking-form-item'}>
										<span className={classNames('title-mid')}>사업자 등록증 첨부</span>
										<div className={classNames('file-form-wrap')}>
											<div className={'file-form-set'}>
												<div className={classNames('file-button-set')}>
													<input
														{...register('businessRegistration')}
														className='hidden'
														ref={inputRef}
														type='file'
														accept='image/*, application/pdf'
														onChange={handleImages} />
													{/* <input ref={inputRef} type='file' accept='image/*, application/pdf' onChange={handleImages} /> */}
													<Button
														styleType='icon'
														onClick={() => inputRef.current.click()}
													// disabled={isExistsImages}
													>
														<Icon icon={'attach'} />
														파일 첨부
													</Button>
												</div>
												{fileManage && <span>{fileManage?.name}</span>}
												{/* {isExistsImages && <span>파일 업로드가 완료되었습니다.</span>} */}

											</div>
											{errors.businessRegistration && !file && (
												<span className={classNames('error')}>
													{errors.businessRegistration.message}
												</span>
											)}
										</div>
									</div>
								</>
							)}
						</>}





						<div className={'booking-form-item'}>
							<span className={classNames('title-mid')}>상품 선택</span>
							<SelectObj
								defaultValue="선택하세요"
								{...register('selectedProduct')}
								options={productList}
								selectedValue={selectedProduct.value}
								error={errors.selectedProduct}
								onOptionChange={(option) => {
									setSelectedProduct(option)
									setValue('contractTypeDay', option?.data?.SubsGoodsDay)
									setValue('contractTypeHour', option?.data?.SubsGoodsHour)
									setValue('mmHourPrice', option?.data?.PerHourAmt)
									setValue('ContractOneDayAvaliableHour', option?.data?.MinApplyHour)
									setSubscribeData((prevState) => ({
										...prevState,
										ContractTypeDay: option?.data?.SubsGoodsDay,
										ContractTypeHour: option?.data?.SubsGoodsHour,
										MmHourPrice: option?.data?.PerHourAmt,
										ContractOneDayAvaliableHour: option?.data?.MinApplyHour,
										SubscriptionType: option?.data?.SubsSType,
										SubscriptionFullText: option?.label,
									}))

									if (option?.data?.SubsSType === 'MONTHLY') {
										saveSubscribeData('PromotionDiscountPercent', 0)
										saveSubscribeData('ContractMonth', 1)

									}
									else {
										saveSubscribeData('ContractMonth', 1)
										saveSubscribeData('ContractMonthDiscountPercent', 0)
									}

									// option = { label: '옵션 1', value: 'opt1', data: { id: 1 } }
									// console.log(option);
								}}
							/>

						</div>
						<div className={'booking-form-item'}>
							<span className={classNames('title-mid')}>상품 상세 내용</span>

							<InputWithLabel
								label='상품(일)'
								type={'text'}
								required
								{...register('contractTypeDay')}
								setValue={setValue}
								error={errors.contractTypeDay}
								onChange={e => {
									setValue('contractTypeDay', e.target.value)
									saveSubscribeData('ContractTypeDay', e.target.value)
								}}
								placeholder={'상품(일)'}
							/>
							<InputWithLabel
								label='상품(시간)'
								type={'text'}
								required
								{...register('contractTypeHour')}
								setValue={setValue}
								error={errors.contractTypeHour}
								onChange={e => {
									setValue('contractTypeHour', e.target.value)
									saveSubscribeData('ContractTypeHour', e.target.value)
								}}
								placeholder={'상품(시간)'}
							/>
							<InputWithLabel
								label='상품 단가'
								type={'text'}
								required
								{...register('mmHourPrice')}
								setValue={setValue}
								error={errors.mmHourPrice}
								onChange={e => {
									setValue('mmHourPrice', e.target.value)
									saveSubscribeData('MmHourPrice', e.target.value)
								}}
								placeholder={'상품 단가'}
							/>

							<InputWithLabel
								label='1일 최소이용시간'
								type={'text'}
								required
								{...register('ContractOneDayAvaliableHour')}
								setValue={setValue}
								error={errors.ContractOneDayAvaliableHour}
								onChange={e => {
									setValue('ContractOneDayAvaliableHour', e.target.value)
									saveSubscribeData('ContractOneDayAvaliableHour', e.target.value)
								}}
								placeholder={'1일 최소이용시간'}
							/>

							{(() => {
								let disabledFlag = false
								let labelText = ''
								if (selectedProduct?.data?.SubsSType === 'MONTHLY') {
									labelText = '월간 개월수 입력'
								}
								else if (selectedProduct?.data?.SubsSType === 'ANNUAL') {
									// labelText = '연간 년수 입력'
									labelText = '연간 개월수 입력'

								}
								else {
									disabledFlag = true
								}

								return (<InputWithLabel
									label={labelText}
									type={'text'}
									value={subscribeData.ContractMonth}
									disabled={disabledFlag}
									required
									{...register('ContractMonth')}
									setValue={setValue}
									error={errors.ContractMonth}
									onChange={e => {
										saveSubscribeData('ContractMonth', e.target.value)
									}}
									placeholder={labelText}
								/>)
							})()}

							<InputWithLabel
								label='프로모션 - 할인율(%)'
								type={'text'}

								value={subscribeData.PromotionDiscountPercent}
								required
								{...register('PromotionDiscountPercent')}
								setValue={setValue}
								error={errors.PromotionDiscountPercent}
								onChange={e => {
									setValue('PromotionDiscountPercent', e.target.value)
									saveSubscribeData('PromotionDiscountPercent', e.target.value)
								}}
								placeholder={'프로모션 - 할인율(%)'}
							/>


							<InputWithLabel
								label='프로모션 - 연장 기간(개월)'
								type={'text'}

								value={subscribeData.PromotionAnnualMonth}
								required
								{...register('PromotionAnnualMonth')}
								setValue={setValue}
								error={errors.PromotionAnnualMonth}
								onChange={e => {
									setValue('PromotionAnnualMonth', e.target.value)
									saveSubscribeData('PromotionAnnualMonth', e.target.value)
								}}
								placeholder={'프로모션 - 연장 기간(개월)'}
							/>

							<InputWithLabel
								label='프로모션 - 충전(시간)'
								type={'text'}

								value={subscribeData.PromotionPrePaidTicket}
								required
								{...register('PromotionPrePaidTicket')}
								setValue={setValue}
								error={errors.PromotionPrePaidTicket}
								onChange={e => {
									setValue('PromotionPrePaidTicket', e.target.value)
									saveSubscribeData('PromotionPrePaidTicket', e.target.value)
								}}
								placeholder={'프로모션 - 충전권 (시간당 3만원 기준)'}
							/>


							{/* 이용 예정일 얘기하긴 한다. */}
							{/*  */}


							{/* <div className={'booking-form-item'}>
								<span className={classNames('small')}>결제 예정일</span>
								<DatePickerInput
									selectedDate={PurchaseDate}
									onDateChange={setPurchaseDate}
									placeholder='--.--.--' />
							</div> */}

							{/* 1주일 뒤까지 */}

							{/* <InputWithLabelAndList
								label='고객인입정보조회'
								type={'text'}
								value={subscribeData.PhoneNumber}
								required
								{...register('joinPhone')}
								setValue={setValue}
								error={errors.joinPhone}
								onChange={e => {
									setValue('joinPhone', e.target.value)
									saveSubscribeData('PhoneNumber', e.target.value)
								}}
								placeholder={'이메일, 전화번호, 이름을 입력하여 조회'}
								listData={tempCustomerList}
								showList={showPhoneList}
								setShowList={setShowPhoneList}
								onSelectItem={(item) => {
									setSelectedTempInfo(item);
									// 선택한 고객 정보로 필드 채우기
									setValue('joinPhone', item.PhoneNumber);
									saveSubscribeData('PhoneNumber', item.PhoneNumber);
									if (item.Email) {
										setValue('joinEmail', item.Email);
										saveSubscribeData('EmailAddress', item.Email);
									}
									if (item.UserName) {
										setValue('joinName', item.UserName);
										saveSubscribeData('CustomerName', item.UserName);
									}
								}}
								listItemRender={(item) => (
									<div>
										<div style={{ fontWeight: 600, color: '#333' }}>
											{item.UserName} ({item.PhoneNumber})
										</div>
										<div style={{ fontSize: '12px', color: '#999', marginTop: '4px' }}>
											{item.Email}
										</div>
										<div style={{ fontSize: '12px', color: '#999', marginTop: '2px' }}>
											고객번호: {item.CustomerNo} | 관리번호: {item.ManageId}
										</div>
									</div>
								)}
							/> */}
						</div>


						{/* title, selected, optionList, saveOptionId */}
						<div className={'booking-form-item'}>
							<span className={classNames('title-mid')}>옵션</span>
							<OptionComponent
								title='운행 등록차량 추가여부'
								selected={selectedOption.option01}
								optionList={[{ title: '없음', price: '0' }, { title: '운행 등록차량 추가', price: '150700' }]}
								saveOptionId={'option01'}
							/>
							<OptionComponent
								title='특장차량'
								selected={selectedOption.option02}
								optionList={[{ title: '없음', price: '0' }, { title: '특장차량 / 2억원 이상', price: '100100' }]}
								saveOptionId={'option02'}
							/>
							<OptionComponent
								title='보험'
								selected={selectedOption.option03}
								optionList={[{ title: '없음', price: '0' }, { title: '고객보험할인', price: '-100100' }]}
								saveOptionId={'option03'}
								discountFlag={true}
							/>
							<OptionComponent
								title='파트너 1인 지명'
								selected={selectedOption.option04}
								optionList={[{ title: '없음', price: '0' }, { title: '파트너 1인 지명', price: '198000' }]}
								saveOptionId={'option04'}
							/>
							<OptionComponent
								title='언어수당'
								selected={selectedOption.option05}
								optionList={[{ title: '없음', price: '0' }, { title: '언어수당', price: '198000' }]}
								saveOptionId={'option05'}
							/>
							<OptionComponent
								title='차량포함'
								selected={selectedOption.option06}
								optionList={[{ title: '없음', price: '0' }, { title: '차량포함', price: '605000' }]}
								saveOptionId={'option06'}
							/>
						</div>

						{/* <div className={'booking-form-item'}>
							<span className={classNames('title-mid')}>회원정보 입력</span>
							<InputWithLabel
								label='이름'
								type={'text'}
								value={subscribeData.CustomerName}
								required
								{...register('joinUserName')}
								setValue={setValue}
								error={errors.joinUserName}
								onChange={e => {
									setValue('joinUserName', e.target.value)
									saveSubscribeData('CustomerName', e.target.value)
								}}
								placeholder={'이름'}
							/>
							<InputWithLabel
								label='계약명'
								type={'text'}
								value={subscribeData.ContractName}
								required
								{...register('joinContractName')}
								setValue={setValue}
								error={errors.joinContractName}
								onChange={e => {
									setValue('joinContractName', e.target.value)
									saveSubscribeData('ContractName', e.target.value)
								}}
								placeholder={'계약명'}
							/>
							<InputWithLabel
								label='이메일주소'
								type={'text'}
								value={subscribeData.EmailAddress}
								required
								{...register('joinEmail')}
								setValue={setValue}
								error={errors.joinEmail}
								onChange={e => {
									setValue('joinEmail', e.target.value)
									saveSubscribeData('EmailAddress', e.target.value)
								}}
								placeholder={'이메일주소'}
							/>
							<InputWithLabel
								label='전화번호'
								type={'text'}
								value={subscribeData.PhoneNumber}
								required
								{...register('joinPhone')}
								setValue={setValue}
								error={errors.joinPhone}
								onChange={e => {
									setValue('joinPhone', e.target.value)
									saveSubscribeData('PhoneNumber', e.target.value)
								}}
								placeholder={'전화번호'}
							/>


							<InputWithLabel
								label='모시러 회원가입여부'
								type={'text'}
								disabled={true}
								value={customerCheckResult?.message || '이메일 or 전번 입력끝나면 1초뒤에 조회됩니다.'}
								// error={errors.joinPhone}
								placeholder={'회원가입여부'}
							// rightIcon={JoinCheckStatusIcon(customerCheckResult.status)}
							/>
						</div> */}



					</div>

					<BookingFormSummary
						hasAmonut={false}
						description={description}>
						{/* <div className={classNames('button-set')}>
							<Button
								styleType={'secondary'}
								type={'submit'}
							>계약서 발행</Button>
						</div> */}

						<div className={classNames('button-set')}>
							{/* <Button
								styleType={'secondary'}
								disabled={true}
								onClick={
									() => EstimatePreview()
								}
							>견적서확인(항목확정되면enable예정)</Button> */}
							<Button
								type={'submit'}
								// disabled={true}
								styleType={'secondary'}
							// onClick={
							// 	() => handlePreviewPopup()
							// }
							>계약서미리보기</Button>

						</div>
					</BookingFormSummary>
				</form>
			</div>

			{popupPreviewFlag && (
				<>
					<PreviewModal />
				</>
			)}

			<div style={{ width: '1px', height: '1px', visibility: 'hidden' }}>
				<iframe src={BackEstimateUrl} style={{ width: '1px', height: '1px', }} />
			</div>

		</>
	)
}

export default UserInformationAdmin;










/*
모두싸인 response
{
"id": "2eae2080-cc32-11f0-9c0a-27e9947d9cf3",
"title": "20251128_라이즈테스트_구독상품_계약",
"status": "ON_PROCESSING",
"requester": {
"email": "monthly2@mosiler.com",
"name": "(주)모시러"
},
"participants": [
{
"id": "2ef98160-cc32-11f0-a8c9-7b531ffc1c34",
"type": "SIGNER",
"name": "라이즈테스트",
"signingOrder": 1,
"signingDue": {
"valid": false,
"datetime": null
},
"signingMethod": {
"type": "EMAIL",
"value": "rise@mosiler.com"
},
"locale": "ko"
}
],
"currentSigningOrder": 0,
"signings": [],
"accessibleByParticipant": true,
"abort": null,
"metadatas": [],
"file": {
"downloadUrl": "https://api.modusign.co.kr/documents/2eae2080-cc32-11f0-9c0a-27e9947d9cf3/file?signedUrlToken=documents%2F2eae2080-cc32-11f0-9c0a-27e9947d9cf3%2FpdfFile%2F01KB4RD8MSBKRAM4DGAH5CXXR3-latest.pdf%3FX-Amz-Algorithm%3DAWS4-HMAC-SHA256%26X-Amz-Content-Sha256%3DUNSIGNED-PAYLOAD%26X-Amz-Credential%3DASIAVSQADUJ353PPP3VF%252F20251128%252Fap-northeast-2%252Fs3%252Faws4_request%26X-Amz-Date%3D20251128T081356Z%26X-Amz-Expires%3D600%26X-Amz-Security-Token%3DIQoJb3JpZ2luX2VjEOj%252F%252F%252F%252F%252F%252F%252F%252F%252F%252FwEaCXVzLWVhc3QtMSJHMEUCIGobAmp2yHexUOWsAPWeyK9ZklXhgdZvffysbUAsEhuAAiEAkMsKd7FJby6egWxkWo0ixOlwXNMPgd9ar17RCk3EGXUqngUIsf%252F%252F%252F%252F%252F%252F%252F%252F%252F%252FARABGgwzODMzMjYwNjkzNjciDJPGItUHEJBvaC83TCryBDd3T8XtWcAPo3RHQyLbRLgwqaKCch%252FMn5rG0z0Bi%252Bp3zGNIMxHTgOlSDAc3GIk1MLJeX9cKmQd9KzRExjR%252FMWeXcYCYFz71Up4Q6W2iwz8coNb92bcfSgK8L2vvWiW5oLniy2FGL0JK5K%252FevaVd%252B%252B42HntDfv%252FdSbXvz1lKvz3uhCGnwapwJw9BpRfFHeohzHpk2Acr%252Bu4zRCgJGnVRPJbYy537f6cYmNAbZyApLHSqyVe0dY2BbyZMpp6VZMyVYIFqHED3DKxmi5qO4xq7vSFTmxRaeht3whcKX8cwC9Jktb5ejcH1w0%252BUftX8eOZzXGJHYUe5GPvPX5NbtfN2wqgGIZXmPavWu7QEp0Uj7rNaxxeQdTrrjhniw1A%252BktGFeQj11b%252BkNnm7C5YW8cRJUvqkvC0kSuHX1iztvHYSnOhmz%252B3nclbiXNjWadCxJfyLfATcMv8XJWz4kCmTa8PPJ73J0Jwx6kKDor6yJnnw4ojPC%252Fuz0cgjhltWTqhWNeMGSUVcLtIMcR1PRHO5dt4gWiUoleKZsAs6bGBU%252BWgN89KbZunHU5%252FRDPMIF%252B%252FvTJs7uL662VnHdfWujYK1PdCPtKqHsFNutnrWm6iOlz8kY9uNut2UdqCGUnrspwGKDN%252BEjTbUSYy1KuBxx6q2Tm2t5Y542lMqWIyA5Rd2KFDrJxxoZNFUqOWevQusGOlbJKcGOlytkQHSCqtgmh4l0A746AxHiJ3%252BP3VgNvRQ77LfysrFl1hGdoseb52Gb30cVRKM8U2IcMU1SCHIYRASRk6wLc%252Bqnad9TfwbFYpzny5m4y4QmXLKm0skCGnlNvhFLh3OBmH7MLWnpckGOpgBJsnzSE1Nh7xrP02x0ngtFMT92ZUXut6qIMggiTw5CDyGl%252FmmenC5N2VdM3j%252FPX3s913YxSjqYkHfPyCbW5WEldOxhjIi6fB%252BC2%252BW2trN0yx%252FBEraf8w4I9NvmB%252BiupuKORpO6C1IMZEmBX7TuAh9ak9v2Ciw5A5CU3lZ9fUP2yTPPblIhAYF8N0CF2itCkFJGTqiFndTb4o%253D%26X-Amz-Signature%3Dd6238aa1298a45eab492d0b9b38800c3c0dc507c7db8a429408176a2d6af2e33%26X-Amz-SignedHeaders%3Dhost%26forcePathStyle%3Dtrue"
},
"auditTrail": null,
"updatedAt": "2025-11-28T08:13:56.000Z",
"createdAt": "2025-11-28T08:13:56.000Z",
"brandId": null
}
 */